import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeCustomerOrderCreate } from './serialize';

/** POST `/crm/customer-order`。不送 customerOrderNo；不送衍生 totals。 */
export async function createCustomerOrder(payload) {
  const { data: raw } = await request.post(
    '/crm/customer-order',
    serializeCustomerOrderCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
